import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class ApiProvider extends HttpService {

    /**
     * Serviço de integração ao backend da nova API via cloudfront
     */
    constructor(http: HttpClient, settingsService: SettingsService) {
        super('api', http, settingsService);
    }

}
